import { useMemo, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../api/client'
import type { Entry } from '../api/entries'
import { getEntry } from '../api/entries'
import { EntryCard } from '../components/Entry/EntryCard'
import { usePageHeader } from '../hooks/usePageHeader'
import { useUsername } from '../hooks/useUsername'
import { useAuthorTheme } from '../hooks/useAuthorTheme'

interface PinRecord {
  pin_id: string
  entry_id: string
  pinned_at: string
}

export function Pins() {
  const username = useUsername()
  useAuthorTheme(username ?? undefined)
  const [entries, setEntries] = useState<Entry[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!username) return
    setLoading(true)
    api.get<PinRecord[]>(`/users/${username}/pins`)
      .then(async (pins) => {
        const loaded = await Promise.all(
          pins.map((p) => getEntry(p.entry_id).catch(() => null))
        )
        const sorted = (loaded.filter(Boolean) as Entry[]).sort(
          (a, b) => b.updated_at.localeCompare(a.updated_at)
        )
        setEntries(sorted)
      })
      .catch(console.error)
      .finally(() => setLoading(false))
  }, [username])

  const titleNode = useMemo(() => (
    username ? (
      <><Link to={`/~${username}`} style={{ color: 'inherit', textDecoration: 'none', opacity: 0.6 }}>~{username}</Link>{' / pins'}</>
    ) : 'pins'
  ), [username])

  const pinsActions = useMemo(() => (
    username ? (
      <a href={`/~${username}/pins.atom`} style={{ fontSize: '0.8rem', opacity: 0.5 }}>atom feed</a>
    ) : undefined
  ), [username])

  usePageHeader(titleNode, pinsActions)

  return (
    <div style={{ marginTop: '-1rem' }}>
      {loading ? (
        <p>loading…</p>
      ) : entries.length === 0 ? (
        <p style={{ opacity: 0.5 }}>nothing pinned yet</p>
      ) : (
        entries.map((e) => (
          <EntryCard
            key={e.id}
            entry={e}
          />
        ))
      )}
    </div>
  )
}
